export const deserializes = {
  stringArray: (v) => (Boolean(v) ? v.split(',') : []),
  numberArray: (v) => (Boolean(v) ? v.split(',').map(Number) : []),
};
